import React, { useRef } from "react";
import { Printer } from "lucide-react";

const LandBeneficiaryList = ({ setSubComponent }) => {
    const printRef = useRef(null);

    const handlePrarupList = () => {
        setSubComponent("LandBeneficiary");
    };
    const handlePrarupReport = () => {
        setSubComponent("LandBeneficiaryReport");
    };
    const handlePrarupRemarks = () => {
        setSubComponent("PrarupList");
    };

    const handlePrint = () => {
        const content = printRef.current.innerHTML;
        const win = window.open("", "", "width=900,height=700");
        win.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            body {
              font-family: "Noto Serif Devanagari", serif;
              padding: 40px;
              color: #000;
            }
          </style>
        </head>
        <body>${content}</body>
      </html>
    `);
        win.document.close();
        win.focus();
        win.print();
        win.close();
    };

    return (
        <div className="p-6 bg-gray-100">
            {/* PRINT BUTTON */}
            <div className="flex justify-start mb-4 gap-3">
               
                <button
                    onClick={handlePrarupList}
                    className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-lg"
                >
                    प्रारूप यादी
                </button>
                <button
                    onClick={handlePrarupReport}
                    className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-lg"
                >
                    प्रारूप प्रसिद्धी अहवाल
                </button>
                <button
                    onClick={handlePrarupRemarks}
                    className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-lg"
                >
                    प्रारूप टिप्पणी 
                </button>
            </div>

          
        </div>
    );
};

export default LandBeneficiaryList;
